import {isDarkTheme} from '../../libs/shared/ui/src/theme/themeTypeHelpers';
import {UserTheme} from '../../libs/shared/ui/src/theme/themeTypes';
import inboxNoConversations1Dark from '../assets/images/dark/inboxNoConversations1.png';
import inboxNoConversations2Dark from '../assets/images/dark/inboxNoConversations2.png';
import inboxNoConversations3Dark from '../assets/images/dark/inboxNoConversations3.png';
import inboxZero1Dark from '../assets/images/dark/inboxZero1.png';
import inboxZero2Dark from '../assets/images/dark/inboxZero2.png';
import searchNoResultsAnywhereDark from '../assets/images/dark/searchNoResultsAnywhere.png';
import inboxNoConversations1 from '../assets/images/inboxNoConversations1.png';
import inboxNoConversations2 from '../assets/images/inboxNoConversations2.png';
import inboxNoConversations3 from '../assets/images/inboxNoConversations3.png';
import inboxZero1 from '../assets/images/inboxZero1.png';
import inboxZero2 from '../assets/images/inboxZero2.png';
import searchNoResultsAnywhere from '../assets/images/searchNoResultsAnywhere.png';

export enum ThemedImageNamesEnum {
  INBOX_ZERO_1 = 'inboxZero1',
  INBOX_ZERO_2 = 'inboxZero2',
  INBOX_NO_CONVERSATIONS_1 = 'inboxNoConversations1',
  INBOX_NO_CONVERSATIONS_2 = 'inboxNoConversations2',
  INBOX_NO_CONVERSATIONS_3 = 'inboxNoConversations3',
  SEARCH_NO_RESULTS_ANYWHERE = 'searchNoResultsAnywhere',
}

export interface ImageInfo {
  src: string;
  height: number;
  width: number;
}

type ImageInfoMap = Record<ThemedImageNamesEnum, ImageInfo>;

const lightImageInfo: ImageInfoMap = {
  inboxZero1: {
    src: inboxZero1,
    height: 395,
    width: 480,
  },
  inboxZero2: {
    src: inboxZero2,
    height: 395,
    width: 480,
  },
  inboxNoConversations1: {
    src: inboxNoConversations1,
    height: 400,
    width: 400,
  },
  inboxNoConversations2: {
    src: inboxNoConversations2,
    height: 400,
    width: 400,
  },
  inboxNoConversations3: {
    src: inboxNoConversations3,
    height: 400,
    width: 400,
  },
  searchNoResultsAnywhere: {
    src: searchNoResultsAnywhere,
    height: 92,
    width: 92,
  },
};

export const darkImageInfo: ImageInfoMap = {
  inboxZero1: {
    src: inboxZero1Dark,
    height: 446,
    width: 510,
  },
  inboxZero2: {
    src: inboxZero2Dark,
    height: 464.5,
    width: 462,
  },
  inboxNoConversations1: {
    src: inboxNoConversations1Dark,
    height: 421,
    width: 412,
  },
  inboxNoConversations2: {
    src: inboxNoConversations2Dark,
    height: 477,
    width: 513,
  },
  inboxNoConversations3: {
    src: inboxNoConversations3Dark,
    height: 475,
    width: 467,
  },
  searchNoResultsAnywhere: {
    src: searchNoResultsAnywhereDark,
    height: 87,
    width: 77,
  },
};

export function findThemedImageInfo(theme: UserTheme, imageName: ThemedImageNamesEnum) {
  if (isDarkTheme(theme)) {
    return darkImageInfo[imageName];
  }

  return lightImageInfo[imageName];
}
